import moment, { Moment } from "moment";
import { Sector } from "./sector.model";

export enum ActionDate {
  weekly = "weekly",
  monthly = "monthly",
  custom = "custom",
}

export enum ActionType {
  all = "all",
  dataset = "dataset",
  model = "model",
  usecase = "usecase",
}

export enum requestedBy {
  all = "all",
  outsideOrganisation = "external_org",
  myOrganisation = "internal_org",
}

export enum organisatioDesignation {
  all = "all",
  analyst = "analyst",
  projectManager = "project_manager",
}

export enum visibility {
  // all = "all",
  open = "open",
  // private = "private",
  restricted = "restricted",
  // shared = "shared",
}

export enum ArtifactType {
  dataset = "dataset",
  model = "model",
  usecase = "usecase",
}

export enum UserType {
  explorer = "EXPLORER",
  contributor = "CONTRIBUTOR",
  orgAdmin = "ORG_ADMIN",
}

export enum OrganizationType {
  ALL = "All",
  PUBLIC = "Public",
  PRIVATE = "Private",
  RESEARCH_ORGANISATION = "Research Organisation",
  UNIVERSITY = "University",
  STARTUP_MSME = "Startup/MSME",
  DEFAULT = "Default",
  NGO_ORGANISATION = "NGO / Not for profit organization",
}

export enum griveanceCategory {
  accessibilityAndUsability = 17,
  artefactUploadAndDownloadIssues = 15,
  organizationAndTeamManagement = 14,
  profileAndAccountIssues = 13,
  reportAArtefact = 12,
  technicalIssues = 16,
  others = 18,
}
export interface ArtefactFilterOptions {
  actionDate: {
    fromDate: Moment | Date | string;
    toDate: Moment | Date | string;
  };
  dateFilterType: { label: string; value: ActionDate };
  requestedBy?: { label: string; value: ActionType }[];
  visibility?: { label: string; value: ActionType }[];
  searchText?: string;
  selectedCheckboxOptions?: string[];
  artifactType?: { label: string; value: ArtifactType }[];
  category?: { label: string; value: griveanceCategory }[];
  sector?: { label: string; value: Sector }[];
  organizationType?: { label: string; value: string }[];
  userType?: { label: string; value: UserType }[];
  sourceOrganization?: { label: string; value: string }[];
}
